// main Import
import React, { useState, useEffect } from "react";

// Custom Css
// import "./executiveDash.css";
import Colors from '../../Global/colors'
import Spinner from "../../Global/Spinner2";

// Material UI Components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";
import Chart from "react-apexcharts";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useTranslation } from "react-i18next";


//Redux
import { useSelector } from "react-redux";




function createData(area, current, previous, trend) {
    return { area, current, previous, trend};
  }

const rows = [
  createData("Area 1", 19, 6),
  createData("Area 2", 87, 90),
  createData("Area 3", 10, 16),
  createData("Area 4", 62, 16),
];

function createData1(question,Score) {
  return {question,Score};
}
function createData2(question,score,total) {
  return {question,score,total};
}

function createData3(inspection,score,aging,inspector) {
  return {inspection,score,aging,inspector};
}

const rows1 = [
createData1("Question1", 19),
createData1("Question2", 87),
createData1("Question3", 10),
createData1("Question4", 62),
createData1("Question5", 19),
createData1("Question6", 87),
createData1("Question7", 10),
createData1("Question8", 62),
];

const rows2 = [
createData1("Question1", 19.5),
createData1("Question2", 87.5),
createData1("Question3", 10.5),
createData1("Question4", 62.7),
createData1("Question5", 19.5),
createData1("Question6", 87.8),
createData1("Question7", 10.1),
createData1("Question8", 62.5),
];

const rows3 = [
  createData2("Question1", 5 ,12),
  createData2("Question2", 2 ,17),
  createData2("Question3", 7 ,20),
  createData2("Question4", 12 ,58),
  createData2("Question5", 12 ,30),
  createData2("Question6", 18 ,22),
  createData2("Question7", 5 ,8),
  createData2("Question8", 12 ,12),
  ];

const rows4 = [
  createData3("Area 1", 19, 6, "mark"),
  createData3("Area 2", 87, 90, 'joe'),
  createData3("Area 3", 10, 16,'tom'),
  createData3("Area 4", 62, 16,'tim'),
  createData3("Area 1", 19, 6, 'sam'),
  createData3("Area 2", 87, 90,'lex'),
  createData3("Area 3", 10, 16,'nofe'),
  createData3("Area 4", 62, 16,'samel'),
];



const useStyles = makeStyles((theme) => ({

  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function ExecutiveDashboard({
  auditQuality,
  auditQualityLoader,
  auditTimeliness,
  auditTimelinessLoader,
  auditMissSchedule,
  auditMissScheduleLoader,
  lowPerformanceSites,
  lowPerformanceSitesLoader,
  weeklyInspections,
  weeklyInspectionsLoader,
  inspectionPerformance,
  inspectionPerformanceLoader,
  companyID,
  to,
  from,
}) {
  const { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const [responses, setResponses] = useState([]);
  const [currentResponses, setCurrentResponses] = useState([]);
  const [chart1, setChart1] = useState({
    series: [
      {
        data: [6, 2, 5, 0],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
        zoom: {
          enabled: true,
          type: "x",
          autoScaleYaxis: false,
          zoomedArea: {
            fill: {
              color: "#90CAF9",
              opacity: 0.4,
            },
            stroke: {
              color: "#0D47A1",
              opacity: 0.4,
              width: 1,
            },
          },
        },
        events: {
          click: function(chart, w, e) {
            // console.log(chart, w, e)
          },
        },
      },

      colors: [
        "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
            ],
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        marker: {
          show: true,
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="arrow_box">' +
            "<span> <b> Count: </b>" +
            series[seriesIndex][dataPointIndex] +
            "</span>" +
            "</div>"
          );
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
        showForSingleSeries: false,
      },
      xaxis: {
        categories: [
          "0 - 2",
          "5 - 7",
          "8 - 12",
          ">12",
          // ["0 - 2", 12], ["5 - 7", 5], ["8 - 12", 1], [">12", 0]
        ],
        labels: {
          style: {
            colors: ["#043077"],
            fontSize: "12px",
          },
        },
      },
    },
  });

  const [chart2, setChart2] = useState({
    series: [
      {
        data: [6, 2, 5, 0],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
        zoom: {
          enabled: true,
        },
        events: {
          click: function(chart, w, e) {
            // console.log(chart, w, e)
          },
        },
      },
      colors: [
        "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
            ],
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
        showForSingleSeries: false,
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        marker: {
          show: true,
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="arrow_box">' +
            "<span> <b> Count: </b>" +
            series[seriesIndex][dataPointIndex] +
            "</span>" +
            "</div>"
          );
        },
      },
      xaxis: {
        categories: ["25%", "50%", "75%", "100%"],
        labels: {
          style: {
            colors: ["#043077"],
            fontSize: "12px",
          },
        },
      },
    },
  });

  const [lineChart, setLineChart] = useState({
    series: [
      {
        name: "Desktops",
        data: [10, 41, 35, 50],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        marker: {
          show: true,
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="arrow_box">' +
            "<span> <b> Score: </b>" +
            series[seriesIndex][dataPointIndex] +
            "%" +
            "</span>" +
            "</div>"
          );
        },
      },
      stroke: {
        curve: "straight",
      },
      grid: {
        row: {
          colors: ["#043077", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
      },
    },
  });

  const [chart1Options, setChart1Options] = useState({});
  const [chart2Options, setChart2Options] = useState({});
  const [chart3Options, setChart3Options] = useState({});
  const [chart4Options, setChart4Options] = useState({});
  const [chart5Options, setChart5Options] = useState({});


  useEffect(
    () => {
      if (auditQuality != null) {
        let data = [...auditQuality.data];
        let category = [...auditQuality.user];

        console.log(data);
        console.log(category);

        let groupOptions = {
          chart: {
            height: 350,
            type: "bar",
            // events: {
            //   click: function(chart, w, e) {
            //     // console.log(chart, w, e)
            //   },
            // },
          },
          colors: [
            "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
                ],
          plotOptions: {
            bar: {
              columnWidth: "45%",
              distributed: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          tooltip: {
            enabled: true,
            fillSeriesColor: false,
            marker: {
              show: true,
            },
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return (
                '<div class="arrow_box">' +
                "<span> <b> Score: </b>" +
                series[seriesIndex][dataPointIndex] +
                "%" +
                "</span>" +
                "</div>"
              );
            },
          },
          xaxis: {
            categories: category,
            labels: {
              style: {
                colors: ["#043077"],
                fontSize: "12px",
              },
            },
          },
        };

        setChart1Options(groupOptions);
      }
    },
    [auditQuality]
  );

  useEffect(
    () => {
      if (auditTimeliness != null) {
        let data = [...auditTimeliness.data];
        let category = [...auditTimeliness.user];

        console.log(data);
        console.log(category);

        let groupOptions = {
          chart: {
            height: 350,
            type: "bar",
            zoom: {
              enabled: true,
            },
            // events: {
            //   click: function(chart, w, e) {
            //     // console.log(chart, w, e)
            //   },
            // },
          },
          colors: [
            "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
                ],
          plotOptions: {
            bar: {
              columnWidth: "45%",
              distributed: true,
            },
          },
          tooltip: {
            enabled: true,
            fillSeriesColor: false,
            marker: {
              show: true,
            },
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return (
                '<div class="arrow_box">' +
                "<span> <b> Score: </b>" +
                series[seriesIndex][dataPointIndex] +
                "%" +
                "</span>" +
                "</div>"
              );
            },
          },

          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
            showForSingleSeries: false,
          },
          xaxis: {
            categories: category,
            labels: {
              style: {
                colors: ["#043077"],
                fontSize: "12px",
              },
            },
          },
        };

        setChart2Options(groupOptions);
      }
    },
    [auditTimeliness]
  );

  useEffect(
    () => {
      if (auditMissSchedule != null) {
        let data = [...auditMissSchedule.data];
        let category = [...auditMissSchedule.user];

        console.log(data);
        console.log(category);

        let groupOptions = {
          chart: {
            height: 350,
            type: "bar",
            zoom: {
              enabled: true,
            },
            // events: {
            //   click: function(chart, w, e) {
            //     // console.log(chart, w, e)
            //   },
            // },
          },
          colors: [
              "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
                  ],
          plotOptions: {
            bar: {
              columnWidth: "45%",
              distributed: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
            showForSingleSeries: false,
          },
          tooltip: {
            enabled: true,
            fillSeriesColor: false,
            marker: {
              show: true,
            },
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return (
                '<div class="arrow_box">' +
                "<span> <b> Score: </b>" +
                series[seriesIndex][dataPointIndex] +
                "%" +
                "</span>" +
                "</div>"
              );
            },
          },
          xaxis: {
            categories: category,
            labels: {
              style: {
                colors: ["#043077"],
                fontSize: "12px",
              },
            },
          },
        };

        setChart3Options(groupOptions);
      }
    },
    [auditMissSchedule]
  );

  useEffect(
    () => {
      if (lowPerformanceSites != null) {
        let data = [...lowPerformanceSites.data];
        let category = [...lowPerformanceSites.user];

        console.log(data);
        console.log(category);

        let groupOptions = {
          chart: {
            height: 350,
            type: "bar",
            // events: {
            //   click: function(chart, w, e) {
            //     // console.log(chart, w, e)
            //   },
            // },
            zoom: {
              enabled: true,
            },
          },
          colors: [
              "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
                  ],
          plotOptions: {
            bar: {
              columnWidth: "45%",
              distributed: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
            showForSingleSeries: false,
          },
          tooltip: {
            enabled: true,
            fillSeriesColor: false,
            marker: {
              show: true,
            },
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return (
                '<div class="arrow_box">' +
                "<span> <b> Count: </b>" +
                series[seriesIndex][dataPointIndex] +
                "</span>" +
                "</div>"
              );
            },
          },
          xaxis: {
            categories: category,
            labels: {
              style: {
                colors: ["#043077"],
                fontSize: "12px",
              },
            },
          },
        };

        setChart4Options(groupOptions);
      }
    },
    [lowPerformanceSites]
  );

  useEffect(
    () => {
      if (weeklyInspections != null) {
        let data = [...weeklyInspections.data];
        let category = [...weeklyInspections.user];

        console.log(data);
        console.log("category", category);

        let groupOptions = {
          chart: {
            height: 350,
            type: "line",
            color: ["#043077"],
            zoom: {
              enabled: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          tooltip: {
            enabled: true,
            fillSeriesColor: false,
            marker: {
              show: true,
            },
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              return (
                '<div class="arrow_box">' +
                "<span> <b> Inspection Count: </b>" +
                series[seriesIndex][dataPointIndex] +
                "</span>" +
                "</div>"
              );
            },
          },
          grid: {
            row: {
              colors: ["transparent"], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            categories:category,
          },
        };

        setChart5Options(groupOptions);
      }
    },
    [weeklyInspections]
  );

  //   useEffect(
  //     () => {
  //       if (plannedToActual != null) {
  //          let groupOptions = {
  //           chart: {
  //             type: 'radialBar',

  //             offsetY: -20,
  //             sparkline: {
  //               enabled: true
  //             }
  //           },
  //           plotOptions: {
  //             radialBar: {
  //               startAngle: -90,
  //               endAngle: 90,
  //               track: {
  //                 background: "#e7e7e7",
  //                 strokeWidth: '97%',
  //                 margin: 5, // margin is in pixels
  //                 dropShadow: {
  //                   enabled: true,
  //                   top: 2,
  //                   left: 0,
  //                   color: '#999',
  //                   opacity: 1,
  //                   blur: 2
  //                 }
  //               },
  //               dataLabels: {
  //                 name: {
  //                   show: false
  //                 },
  //                 value: {
  //                   offsetY: -2,
  //                   fontSize: '22px'
  //                 }
  //               }
  //             }
  //           },
  //           grid: {
  //             padding: {
  //               top: -10
  //             }
  //           },
  //           fill: {
  //             type: "gradient",
  //             gradient: {
  //               shade: "dark",
  //               shadeIntensity: 1,
  //               opacityFrom: 0.7,
  //               opacityTo: 0.9,
  //               colorStops: [
  //                 {
  //                   offset: 0,
  //                   color: "#01defe",
  //                   opacity: 1
  //                 },
  //                 {
  //                   offset: 20,
  //                   color: "#1459f3",
  //                   opacity: 1
  //                 },
  //               ]
  //             }
  //           },
  //           stroke: {
  //             lineCap: "round"
  //           },
  //           labels: ['Average Results'],
  //         };

  //         setRadialChart1(groupOptions);
  //       }
  //     },[plannedToActual]
  //   );

  //   useEffect(
  //     () => {
  //       if (timeliness != null) {
  //          let groupOptions = {
  //           chart: {
  //             type: 'radialBar',
  //             offsetY: -20,
  //             sparkline: {
  //               enabled: true
  //             }
  //           },
  //           plotOptions: {
  //             radialBar: {
  //               startAngle: -90,
  //               endAngle: 90,
  //               track: {
  //                 background: "#e7e7e7",
  //                 strokeWidth: '97%',
  //                 margin: 5, // margin is in pixels
  //                 dropShadow: {
  //                   enabled: true,
  //                   top: 2,
  //                   left: 0,
  //                   color: '#999',
  //                   opacity: 1,
  //                   blur: 2
  //                 }
  //               },
  //               dataLabels: {
  //                 name: {
  //                   show: false
  //                 },
  //                 value: {
  //                   offsetY: -2,
  //                   fontSize: '22px'
  //                 }
  //               }
  //             }
  //           },
  //           grid: {
  //             padding: {
  //               top: -10
  //             }
  //           },
  //           fill: {
  //             type: "gradient",
  //             gradient: {
  //               shade: "dark",
  //               shadeIntensity: 1,
  //               opacityFrom: 0.7,
  //               opacityTo: 0.9,
  //               colorStops: [
  //                 {
  //                   offset: 0,
  //                   color: "#01defe",
  //                   opacity: 1
  //                 },
  //                 {
  //                   offset: 20,
  //                   color: "#1459f3",
  //                   opacity: 1
  //                 },
  //               ]
  //             }
  //           },
  //           stroke: {
  //             lineCap: "round"
  //           },
  //           labels: ['Average Results'],
  //         };

  //         setRadialChart2(groupOptions);
  //       }
  //     },[timeliness]
  //   );

  //   useEffect(
  //     () => {
  //       if (failureToActionPlan != null) {
  //          let groupOptions = {
  //           chart: {
  //             type: 'radialBar',
  //             offsetY: -20,
  //             sparkline: {
  //               enabled: true
  //             }
  //           },
  //           plotOptions: {
  //             radialBar: {
  //               startAngle: -90,
  //               endAngle: 90,
  //               track: {
  //                 background: "#e7e7e7",
  //                 strokeWidth: '97%',
  //                 margin: 5, // margin is in pixels
  //                 dropShadow: {
  //                   enabled: true,
  //                   top: 2,
  //                   left: 0,
  //                   color: '#999',
  //                   opacity: 1,
  //                   blur: 2
  //                 }
  //               },
  //               dataLabels: {
  //                 name: {
  //                   show: false
  //                 },
  //                 value: {
  //                   offsetY: -2,
  //                   fontSize: '22px'
  //                 }
  //               }
  //             }
  //           },
  //           grid: {
  //             padding: {
  //               top: -10
  //             }
  //           },
  //           fill: {
  //             type: "gradient",
  //             gradient: {
  //               shade: "dark",
  //               shadeIntensity: 1,
  //               opacityFrom: 0.7,
  //               opacityTo: 0.9,
  //               colorStops: [
  //                 {
  //                   offset: 0,
  //                   color: "#01defe",
  //                   opacity: 1
  //                 },
  //                 {
  //                   offset: 20,
  //                   color: "#1459f3",
  //                   opacity: 1
  //                 },
  //               ]
  //             }
  //           },
  //           stroke: {
  //             lineCap: "round"
  //           },
  //           labels: ['Average Results'],
  //         };

  //         setRadialChart3(groupOptions);
  //       }
  //     },[failureToActionPlan]
  //   );

  const selectResponse = async (e) => {
    console.log("current Response ID ", e.target.value);
    console.log("companyID ", companyID ? companyID : company.id);
    console.log("To Date ", to);
    console.log("From Date ", from);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: e.target.value,
      from_date: from,
      to_date: to,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    await fetch(GlobalApi + "/Dashboard/on_response_changes?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          console.log("DATA FROM Second Api", response);
          let data = [];
          let total = 0;
          response.data.forEach((item) => {
            total = total + parseInt(item.count);
          });

          console.log("TOTAL COUNT ", total);
          let newRes = [["complete", "incomplete"]];
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              newRes.push([item.title, parseInt(item.count)]);
              data.push({ title: item.title, score: parseInt(item.count) });
            });
          }

          console.log(newRes);
          setCurrentResponses(data);
          setResponses(newRes);
          // if (isNaN(response.plannedToActualRatio)) {
          //   setPlannedToActual(0);
          // } else {
          //   setPlannedToActual(response.plannedToActualRatio);
          // }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            selectResponse();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const classes = useStyles();

  return <Grid container spacing={0} style={{ justifyContent: "space-between", flexDirection: "column", backgroundColor: Colors.globalColor9,marginTop: "0px", boxShadow: "none" }} justifyContent="space-between" className="fliterBox">
      {/* ================================== Section 2 Begins =================================== */}
      <Grid item xs={12} justifyContent="center" alignItems="center">
        <div style={{ width: "100%", padding: "10px",backgroundColor: "white" }}>
          <Grid container spacing={2} justifyContent="space-between" alignItems="center" className="fliterBox" style={{ padding: "5px", boxShadow: "none" }}>
            <Grid item xs={12} sm={12} lg={4} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", height: "300px", borderRadius: "10px", border: "1px solid #dadada", display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8, margin: "5px" }}>
                          {t("Quality of Inspector")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("Indicates inspector’s performance on the basis of approvals by superiors.")}>
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                      {auditQualityLoader ? <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div> : <>
                          {" "}
                          {auditQuality == undefined ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: 0 }}>
                          <Chart options={chart1Options} series={[{ data:[] }]} type="bar" height={230} width={"100%"} />
                            </div> : <div id="chart">
                              <Chart options={chart1Options} series={[{ data: auditQuality.data }]} type="bar" height={"100%"} width={"100%"} />
                            </div>}{" "}
                        </>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} lg={4} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", height: "300px", borderRadius: "10px", border: "1px solid #dadada", display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8, margin: "5px" }}>
                          {t("Inspector Timeliness")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("How timely an inspector completes the assigned inspections.")}>
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                      {auditTimelinessLoader ? <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div> : <>
                          {" "}
                          {auditTimeliness == undefined ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
                          <Chart options={chart1Options} series={[{ data:[] }]} type="bar" height={230} width={"100%"} />
                            </div> : <div id="chart">
                              <Chart options={chart2Options} series={[{ data: auditTimeliness.data }]} type="bar" height={230} width={"100%"} />
                            </div>}
                        </>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} lg={4} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", height: "300px", borderRadius: "10px", border: "1px solid #dadada", display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8, margin: "5px" }}>
                          {t("Inspection Start On-time")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("How timely an inspector starts the assigned inspections.")}>
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                      {auditMissScheduleLoader ? <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div> : <>
                          {auditMissSchedule == undefined ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
                          <Chart options={chart1Options} series={[{ data:[] }]} type="bar" height={230} width={"100%"} />
                            </div> : <div id="chart">
                              <Chart options={chart3Options} series={[{ data: auditMissSchedule.data }]} type="bar" height={230} width={"100%"} />
                            </div>}
                        </>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} justifyContent="space-between" alignItems="center" className="fliterBox" style={{ padding: "5px", boxShadow: "none" }}>
            <Grid item xs={12} sm={12} lg={4} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", height: "300px", borderRadius: "10px", border: "1px solid #dadada", display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8, margin: "5px" }}>
                          {t("Failing Sites")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title="The analysis helps uncover the site(s) which are having most failed items reported during the inspections.">
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                      {lowPerformanceSitesLoader ? <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div> : <>
                          {lowPerformanceSites == undefined ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
                          <Chart options={chart1Options} series={[{ data:[] }]} type="bar" height={230} width={"100%"} />
                            </div> : <div id="chart">
                              <Chart options={chart4Options} series={[{ data: lowPerformanceSites.data }]} type="bar" height={230} width={"100%"} />
                            </div>}
                        </>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} lg={4} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", height: "300px", borderRadius: "10px", border: "1px solid #dadada", display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8, margin: "5px" }}>
                          {t("Inspection Conduction Trend")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("Trend of conducted inspections on the weekly basis.")}>
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                      {weeklyInspectionsLoader ? <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div> : <>
                          {" "}
                          {weeklyInspections == undefined ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
                          <Chart options={chart5Options} series={[{ data:[] }]} type="bar" height={230} width={"100%"} />
                            </div> : <div id="chart">
                              <Chart options={chart5Options} series={[{ data: weeklyInspections.data }]} type="line" height={200} width={"100%"} />
                            </div>}
                        </>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} lg={4} justifyContent="center" alignItems="center">
              <div style={{ width: "100%", height: "300px", borderRadius: "10px", border: "1px solid #dadada", display: "flex", overflow: "hidden" }}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                  <Grid item xs={12} justifyContent="flex-start" alignItems="center">
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div style={{ flex: "2" }}>
                        <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8, margin: "5px" }}>
                          {t("Inspection Performance Score")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("Find whether your inspection performance falls into the satisfactory or unsatisfactory range based on the aggregated inspection scores during a specific time period, represented on a bar chart.")}>
                          <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} justifyContent="center" alignItems="center" style={{ padding: "10px" }}>
                    <div style={{ width: "100%", height: "100%" }}>
                    {inspectionPerformanceLoader ? <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div> : <>{inspectionPerformance.length == 0 ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", padding: "0px" }}>
                    <Chart options={chart2.options} series={[{ data:[] }]} type="bar" height={230} width={"100%"} />
                        </div> : <div id="chart">
                          <Chart options={chart2.options} series={[{ data: inspectionPerformance }]} type="bar" height={230} width={"100%"} />
                        </div>}</>}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/* ================================== Section 3 Ends =================================== */}
    </Grid>;
}

export default ExecutiveDashboard;
